import React from "react";
import PropTypes from "prop-types";
import styles from './Chart.less';
import * as d3 from 'd3';
 import { scaleTime } from "d3-scale";
 import { format } from "d3-format";
 import { timeFormat } from "d3-time-format";
import {
EdgeIndicator
} from "react-stockcharts/lib/coordinates";
import { ChartCanvas, Chart } from "react-stockcharts";
import {
    LineSeries,
} from "react-stockcharts/lib/series";
import { XAxis, YAxis } from "react-stockcharts/lib/axes";
import {
	mouseBasedZoomAnchor
} from "react-stockcharts/lib/utils/zoomBehavior";
import { HoverTooltip } from "react-stockcharts/lib/tooltip";
import { fitWidth } from "react-stockcharts/lib/helper";
import { last } from "react-stockcharts/lib/utils";
import CustomOHLCTooltip from './CustomOHLCTooltip';
import i18next from 'i18next';
import config from './../../config';
import $ from 'jquery';
import { connect } from 'react-redux';
import * as commonActions from './../../actions/commonActions';
let dynamicTime = true;
@connect(
  state => ({
  selectedCssColor:state.dashboardRoot.commonReducer.selectedCssColor,
  language:state.dashboardRoot.commonReducer.language
}),
{ ...commonActions})
class LineAndScatterChart extends React.Component {
    componentDidMount() {
        this.node.subscribe("zoomlistner", { listener: this.handleEvents });
    }
    componentWillUnmount() {
        // this.node.unsubscribe("zoomlistner")
    }
    handleEvents = (type, moreProps, state) => {
      try{
        if (type === "zoom" || type === "panend") {
            if (this.props.onZoomEvent) {
                this.props.onZoomEvent(moreProps.xScale.domain());
            }
        }
      }catch(e){
        this.props.logFileCreation({error:e.message, originFunction:'handleEvents', component:"LineAndScatterChart"});
      }
    }
    render() {
        const { data, type, width, ratio, durationType, zoomSet, liveCategory, decimals } = this.props;
        $(document).ready(function(){
          $("rect").hover(function(){
            dynamicTime = false;
          },
          function(){
            dynamicTime = true;
          });
        });
        const xAccessor = d => d && d.date ? d.date : '';
        let testmsg = "Line";
        const start = xAccessor(data[0]);
        const end = xAccessor(data[data.length - 1]);
        //const xExtents = [start, end];
        var margin = {
            top: 20,
            right: 0,
            bottom: 40,
            left: 70
        };
        var dataLength = 0;
        if (this.props.data.length !== 0 ) {
          dataLength = Number(this.props.data[this.props.data.length-1].Price).toLocaleString(navigator.language,{ minimumFractionDigits:this.props.decimals,maximumFractionDigits:this.props.decimals}).length;
        }
        var height = (this.props.height > 400 ? this.props.height : 380 ) - margin.top - margin.bottom;
        var gridHeight = height - margin.top - margin.bottom;
        var gridWidth = width - (this.props.width < 427 ? (dataLength>6 ? 73 : 60) : dataLength >0 && dataLength>6 ? 100 : 70);
        var color='#000';
        var axisColor='#000';
        var yGrid =  {
            innerTickSize: -1 * (width - 70),
            tickStrokeDasharray: 'Solid',
            tickStrokeOpacity: 0.2,
            tickStrokeWidth: 1,
            tickStroke:color,
            stroke: axisColor
        };
        var xGrid = {
            innerTickSize: -1 * gridHeight,
            tickStrokeDasharray: 'Solid',
            tickStrokeOpacity: 0.2,
            tickStrokeWidth: 1,
            tickStroke:color,
            stroke: axisColor
        } ;
        var yGridDark =  {
            innerTickSize: -1 * (width - 70),
            tickStrokeDasharray: 'Solid',
            tickStrokeOpacity: 0.3,
            tickStrokeWidth: 1,
            tickStroke:"#b2b1ae",
            stroke: "#b2b1ae"
        };
        var xGridDark = {
            innerTickSize: -1 * gridHeight,
            tickStrokeDasharray: 'Solid',
            tickStrokeOpacity: 0.3,
            tickStrokeWidth: 1,
            tickStroke:"#b2b1ae",
            stroke: "#b2b1ae"
        } ;
        const defTickTimeFormat = timeFormat("%H:%M:%S");

        let tickTimeFormat = d3.time.format.multi([
          [".%Lms", function(d) { return d.getMilliseconds(); }],
          [":%Ss", function(d) { return d.getSeconds(); }],
          ["%H:%M", function(d) { return d.getHours() || d.getMinutes(); }],
          ["%H:%M", function() { return true }]
        ]);

        var tickFormatFn = function(d) {
          return tickTimeFormat(d);
        };
        var numberFormat = function(d) {
          return d.toLocaleString(navigator.language,{ minimumFractionDigits:decimals,maximumFractionDigits:decimals});
        }
        let tooltipContent = ({ currentItem }) => {
          if (this.props.language == 'AR') {
            return {
              x: defTickTimeFormat(currentItem.date) + ': '+i18next.t('time'),
              y: [{
                    label: Number(currentItem.Price).toLocaleString(navigator.language,{ minimumFractionDigits:this.props.decimals,maximumFractionDigits:this.props.decimals}),
                    value: i18next.t('price'),
                }].filter(line => line.value)
            };
          }
          else {
            return {
              x: i18next.t('time') + ': '+defTickTimeFormat(currentItem.date),
              y: [{
                    label: i18next.t('price'),
                    value: Number(currentItem.Price).toLocaleString(navigator.language,{ minimumFractionDigits:this.props.decimals,maximumFractionDigits:this.props.decimals}),
                }].filter(line => line.value)
            };
          }
        }
        // Graph Color: Ask? Green : Red
        let graphLineColor = liveCategory === 'Ask'? config.increaseRateColor : config.decreaseRateColor;
        let widthConst = (this.props.width < 530 ? 350 : 350 );
        let ohlcTooltipOrigin = [
            this.props.width< 500 ? -40 : (this.props.language != 'AR' ? 0 : 500),
            -38
          ];
          //---to re-render chart zoom-level
          //fetching whole day data from api and showing minutes for minutes by setting the zoomlevel for initial loading
          let a = zoomSet;
        if (data.length< 200) {
          a = start;
        }
        const zoomLevel = this.props.zoomLevel ? this.props.zoomLevel.map((item) => new Date(item)) : undefined;
        const xExtents = zoomLevel !== undefined ? [zoomLevel[0]  ,end] : [a, end];
        return (
          <ChartCanvas ratio={ratio} width={width} height={height}
                  margin={margin}
                  seriesName="Line"
                  data={data}
                  //clamp={"both"}
                  xScale={scaleTime()}
                  xAccessor={xAccessor}
                  displayXAccessor={xAccessor}
                  ref={node => { this.node = node; } }
                  xExtents={xExtents}
                  pointsPerPxThreshold={120}
              >
                <Chart id={1}
                    yExtents={d => [d.Price + Math.pow(10, -1 * (decimals-1)), d.Price - Math.pow(10, -1 * (decimals-1))]}
                >
                { this.props.selectedCssColor==="DR" ?
                  <XAxis axisAt="bottom"  orient="bottom"  tickFormat={tickFormatFn}  ticks={6} {...xGridDark} />

                  :  <XAxis axisAt="bottom"  orient="bottom"  tickFormat={tickFormatFn}  ticks={6} {...xGrid} />
                }
                { this.props.selectedCssColor==="DR" ?
                <YAxis
                       axisAt="left"
                       orient="left"
                       {...yGridDark}
                       zoomEnabled={false}
                       tickFormat={numberFormat}
                   />
                   :
                 <YAxis
                        axisAt="left"
                        orient="left"
                        {...yGrid}
                        zoomEnabled={false}
                        tickFormat={numberFormat}
                    />
                  }

                    <LineSeries
                        yAccessor={d => d.Price}
                        strokeDasharray="Solid"
                        stroke={graphLineColor}
                        connectNulls= {true}
                    />
                    {/* <EdgeIndicator
                        itemType="last"
                        orient="right"
                        edgeAt="right"
      						      yAccessor={d => d.Price}
                        displayFormat={format(",." + decimals + "f")}
                        fill={graphLineColor}
                        arrowWidth={0}
                        rectHeight={18}
                    /> */}
                    <HoverTooltip
                        tooltipContent={tooltipContent}
                        fontSize={13}
                        bgfill={this.props.selectedThemes.tooltipHoverBg}
                        fill={this.props.selectedThemes.tooltipHoverBg}
                        fontFill={this.props.selectedThemes.tooltipHoverClr}
                        stroke={this.props.selectedThemes.tooltipHoverClr}
                        />
                    <CustomOHLCTooltip
                        lineHeader={testmsg}
                        fontSize={13}
                        className={this.props.language != 'AR' ? `${styles.ohlcTooltip}` : `${styles.ohlcTooltip} chartTimeHead`}
                        origin={ohlcTooltipOrigin}
                        ohlcFormat={decimals}
                        lastPointFromGraph={data[data.length-1]}
                        dynamicTimeLine={dynamicTime}
                        zoomWidth={this.props.width}
                        styleObj = {this.props.styleObj}
                    />
                </Chart>
            </ChartCanvas>

        );
    }
}

LineAndScatterChart.propTypes = {
    data: PropTypes.array.isRequired,
    width: PropTypes.number.isRequired,
    ratio: PropTypes.number.isRequired,
    type: PropTypes.oneOf(["svg", "hybrid"]).isRequired,
    durationType: PropTypes.oneOf(['Tick', 'Minute', 'Hour']).isRequired,
    liveCategory: PropTypes.oneOf(['Bid', 'Ask']).isRequired,
    onZoomEvent: PropTypes.func,
    zoomLevel: PropTypes.array
};

LineAndScatterChart.defaultProps = {
    type: "svg",
};
LineAndScatterChart = fitWidth(LineAndScatterChart);

export default LineAndScatterChart;
